// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2t6pE","inner":"Footer_inner__sZrBK","nextIcon":"Footer_nextIcon__3dPZ6","innerLeft":"Footer_innerLeft__1gyJ6"};